<template>
    <div>
        <h3>本を探す</h3>
        <div>
            <p>
                本を探すには、ナビゲーションバーの「書籍検索」に検索文字列を入力してEnter（スマホでは改行）してください。
                検索画面が開きます。
            </p>
            <h4>検索の対象</h4>
            <p>
                小説を検索する時、検索文字列の対象になっているのは以下のとおりです。
            </p>
            <ol>
                <li>タイトル…全文検索。</li>
                <li>サブタイトル…全文検索。</li>
                <li>紹介文…全文検索。</li>
                <li>タグ…完全一致。</li>
                <li>作者名…前方一致</li>
            </ol>
            <p>
                全文検索では、検索文字列が含まれるかどうかの判定が行われます。
                完全一致では完全に同一でなければなりません。
                作者名はふりがなも含めて前方一致ですので、「加藤」で検索すれば、
                「加藤道夫」も「加藤保憲」もヒットします。
            </p>
            <h4>ポータルに表示される小説</h4>
            <p>
                ポータルにリストされる小説は、貸し本棚独自のロジックで一覧化された書籍です。
                ランキングとは異なりますが、ここから読みたい書籍を無作為にみつけることもできます。
                この一覧は一定ではなく、常に変化します。
            </p>
            <h4>SNS</h4>
            <p>
                貸し本棚は通常の小説投稿サイトと異なり、作家さんごとに本棚を設置するためのサイトです。
                そのため、作家さん自身がSNSなどで本棚を宣伝されていることがあります。
                そこから本棚にアクセスし、本を探すことができます。
            </p>
            <h4>小説一覧</h4>
            <p>
                <router-link to="/novels/news">小説一覧</router-link>から、貸し本棚に登録されているすべての小説を参照することができます。
                但し、レーティングで許可していないもの、作者がポータル表示を許可していない作品は表示されません。
                小説一覧の作品は、登録日が新しいものから順に表示されます。
                ポータルの一覧とは異なります。
            </p>
        </div>
    </div>
</template>

<style src="../help.scss" scoped lang="scss"></style>

<script>
export default {
    created() {
        this.useHead({
            title: "本を探す | 貸し本棚ヘルプ",
            link: [
                {
                    rel: "canonical",
                    href: location.origin + location.pathname,
                    id: "canonical"
                }
            ]
        });
    }
}
</script>